import "@hdb/biome-2/bundle.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./App.scss";
import FooterComponent from "./core/components/footer/footer.component";
import SlaRoutes from "./core/routes/app.routes";
import IdleTimeOutHandler from "./core/timeout/idle-time-out-handler";
import { useAppDispatch } from "./store/hooks";
import { hideNav } from "./store/slices/navconfig.slice";
import { trimPastedText } from "./shared/helpers/trim-pasted-text";
// import './bundle.css';

function App() {
  const dispatch = useAppDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const [isActive, setIsActive] = useState(false);
  /*   const [socketStatus, setSocketStatus] = useState("initial");
  const [isCallRetry, setIsCallRetry] = useState(false); */

  const countRef = useRef(0);

  const notifications = useSelector((state: any) => {
    return state.notification.totalNotifications;
  });

  useEffect(() => {
    countRef.current = notifications;
  }, [notifications]);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });

  const handleResize = () => {
    const screenWidth = document.documentElement.clientWidth;
    if (screenWidth < 900) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  // create an event listener
  useEffect(() => {
    window.addEventListener("resize", handleResize);
  });

  useEffect(() => {
    if (isMobile) {
      dispatch(hideNav(true));
    } else {
      dispatch(hideNav(false));
    }
  }, [isMobile]);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [location]);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div
          onPasteCapture={trimPastedText}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              minHeight: "100vh",
            }}
          >
            <IdleTimeOutHandler
              onActive={() => {
                setIsActive(true);
              }}
              onIdle={() => {
                setIsActive(false);
              }}
            />
            <QueryClientProvider client={queryClient}>
              <SlaRoutes />{" "}
            </QueryClientProvider>
          </div>
          <div>
            <FooterComponent />
          </div>
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
